export type OnboardingStepType = 'welcome' | 'spotlight';

export interface OnboardingStep {
    id: string;
    type: OnboardingStepType;
    titleKey: string;
    title: string;
    descriptionKey: string;
    description: string;
    targetSelector?: string;
}

export const createHomeOnboardingSteps = (): OnboardingStep[] => [
    {
        id: 'welcome',
        type: 'welcome',
        titleKey: 'home.onboarding.welcome.title',
        title: 'Welcome to NordInsight',
        descriptionKey: 'home.onboarding.welcome.description',
        description:
            'NordInsight helps radiology teams standardize MRI safety workflows, from implant decisions to policies, approvals, and documentation. This short guide will help you get familiar with the key parts of the platform.',
    },
    {
        id: 'implant-search',
        type: 'spotlight',
        targetSelector: '[class*="SuggestionSearch_input"]',
        titleKey: 'home.onboarding.search.title',
        title: 'Search',
        descriptionKey: 'home.onboarding.search.description',
        description:
            'Search implants, policies, and folders to quickly find safety information, MRI compatibility, and relevant documentation.',
    },
    {
        id: 'history',
        type: 'spotlight',
        targetSelector: '[data-onboarding-target="history"], a[href="/history"]',
        titleKey: 'home.onboarding.history.title',
        title: 'History',
        descriptionKey: 'home.onboarding.history.description',
        description:
            'Use History to quickly return to implants you have viewed before.',
    },
    {
        id: 'all-implants',
        type: 'spotlight',
        targetSelector: '[data-onboarding-target="all-implants"], a[href="/all"]',
        titleKey: 'home.onboarding.allImplants.title',
        title: 'All Implants',
        descriptionKey: 'home.onboarding.allImplants.description',
        description:
            'Browse the full implant list and filter implants by manufacturer, body placement, or type.',
    },
    {
        id: 'bookmarks',
        type: 'spotlight',
        targetSelector: 'a[href="/bookmarks"]',
        titleKey: 'home.onboarding.bookmarks.title',
        title: 'Bookmarks',
        descriptionKey: 'home.onboarding.bookmarks.description',
        description:
            'Bookmark implants directly from implant pages and access them here whenever you need them.',
    },
];
